// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__BJ1ax"};